export default {
  /* Walls */
  0: "$1_wall_SE",
  1: "$1_wall_EW",
  2: "$1_wall_SW",
  3: "$1_wall_NS",

  4: "$1_floor",

  5: "$1_wall_SN",
  6: "$1_wall_NE",
  7: "$1_wall_WE",
  8: "$1_wall_NW",
  /* gates */
  9: "$1_wall_SE",
  10: "$1_wall_EW",
  11: "$1_wall_SW",
  12: "$1_wall_NS",
  15: "$1_wall_SN",
  16: "$1_wall_NE",
  17: "$1_wall_WE",
  /* tri walls */
  18: "$1_triwall_EWS",
  20: "$1_triwall_ENS",
  24: "$1_triwall_WNS",
  26: "$1_triwall_EWN",
  /* quad wall */
  22: "$1_quadwall",
  /* corner walls */
  19: "$1_corner_NW",
  21: "$1_corner_SE",
  23: "$1_corner_NE",
  25: "$1_corner_SW",
};
